import React from "react"

import { CloseIcon } from "@chakra-ui/icons"
import {
  Box,
  Button,
  HStack,
  ModalContent,
  ModalHeader,
} from "@chakra-ui/react"

import Popup from "components/popup/Popup"

import { AlertProps } from "./types"

const Alert: React.FC<AlertProps> = ({
  isOpen,
  onClose,
  title,
  isShowCloseButton = true,
  children,
  primaryButtonText,
  secondaryButtonText = "Cancel",
  primaryButtonOnClick,
  secondaryButtonOnClick,
  isPrimaryActionLoading = false,
}) => (
  <Popup isOpen={isOpen} onClose={onClose}>
    <ModalContent
      alignSelf={{
        base: "flex-end",
        md: "center",
      }}
      borderBottomRadius={{ base: "0px", md: "20px" }}
      borderRadius='20px'
      marginBottom={{ base: "0px", md: "3.75rem" }}
      width={{ base: "100%", md: "693px" }}
      bg='#E4FCF9'
      textAlign='center'
    >
      {title ||
        (isShowCloseButton && (
          <Box
            display='flex'
            justifyContent='space-between'
            paddingX='32px'
            paddingTop='32px'
            paddingBottom='16px'
          >
            <ModalHeader>{title}</ModalHeader>
            {isShowCloseButton && (
              <CloseIcon color='#006f80' cursor='pointer' onClick={onClose} />
            )}
          </Box>
        ))}
      {children}
      <HStack
        display='flex'
        justifyContent='space-between'
        paddingX='48px'
        paddingBottom='48px'
        paddingTop='40px'
      >
        <Button variant='tertiary' flex='1' onClick={secondaryButtonOnClick}>
          {secondaryButtonText}
        </Button>
        <Button
          variant='primary'
          flex='1'
          marginLeft='20px'
          onClick={primaryButtonOnClick}
          isLoading={isPrimaryActionLoading}
        >
          {primaryButtonText}
        </Button>
      </HStack>
    </ModalContent>
  </Popup>
)

export default Alert
